import { useTranslation } from 'next-i18next';
import React, { ComponentPropsWithRef, FC, PropsWithChildren, useContext } from 'react';
import { FadeInElement } from '@components/animations/FadeInElement/FadeInElement.component';
import { PrimaryButton, UnderlinedButton } from '@components/buttons/FlatButton/FlatButton.component';
import { IconButton } from '@components/buttons/IconButton/IconButton.component';
import { CloseIcon } from '@components/icons/Close.icon';
import { Text } from '@components/Text/Text.component';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { PlcColor } from '@styles/colors';
import { Constants } from '@utils/Constants';
import { usePlcRouter } from '@utils/customHooks';
import { urlEnum } from '@utils/url';
import classnames from 'classnames';
import { GeneralContext } from 'features/business/app.contexts';

type Props = ComponentPropsWithRef<'div'>;

const DownloadAppBanner: FC<PropsWithChildren<Props>> = ({ className }) => {
  const { showAppBanner, setShowAppBanner } = useContext(GeneralContext);
  const isMobile = useIsBreakpointDown(Breakpoint.m);
  const { push, route } = usePlcRouter();
  const { t } = useTranslation(['common']);
  // const [device, setDevice] = useState<'iOS' | 'Android' | 'other'>('other');

  // useEffect(() => {
  //   const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  //   setDevice(getDeviceType(userAgent));
  // }, []);

  const rootClassName = classnames(className, 'plc-app-banner', route === urlEnum.search ? 'journal-page' : '');

  function handleOnClick() {
    if (isMobile) {
      // return window.open(device === 'iOS' ? Constants.STORE.APPLE : Constants.STORE.GOOGLE, '_blank');
      return window.open(Constants.STORE.GOOGLE, '_blank');
    }
    return push(urlEnum.landingPage);
  }

  return (
    <FadeInElement animateHeight={false} className={rootClassName} show={showAppBanner}>
      <div>
        <Text
          className="app-banner-text"
          flavour="bleu-light-turquoise"
          i18nKey={isMobile ? 'landing-app.banner.text.mobile' : 'landing-app.banner.text.desktop'}
          onClick={handleOnClick}
          variant={isMobile ? 'h6' : 'h5'}
        >
          <PrimaryButton
            className="app-banner-btn"
            isBleuLightTurquoise
            isExtraSmall
            textProps={{ i18nKey: 'landing-app.banner.download-link.mobile', variant: 'menu-link' }}
          />
          <UnderlinedButton
            className="app-banner-link"
            textProps={{
              flavour: 'bleu-light-turquoise',
              i18nKey: 'landing-app.banner.download-link.desktop',
              variant: isMobile ? 'h6' : 'h5',
            }}
          />
        </Text>
        <IconButton
          className="app-banner-icon"
          onClick={() => {
            setShowAppBanner(false);
          }}
          title={t('common.close')}
        >
          <CloseIcon fillColor={PlcColor.BLEU_LIGHT_TURQUOISE} width={isMobile ? 14 : 20} />
        </IconButton>
      </div>
    </FadeInElement>
  );
};

export { DownloadAppBanner };
